(function () {
    'use strict';

    angular
            .module('imnApp')
            .directive('invalidIf', invalidIf);

    function invalidIf() {
        var directive = {
            require: 'ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, elm, attrs, ctrl) {
            var argsObject = scope.$eval(attrs.invalidIf);

            if (!angular.isObject(argsObject)) {
                argsObject = {invalidIf: attrs.invalidIf};
            }

            for (var validationKey in argsObject) {
                scope.$watch(argsObject[validationKey], function (newVal) {
                    ctrl.$setValidity(validationKey, !newVal);
                });
            }
        }
    }
})();